import { Spin } from "antd";
import React from "react";
import { useParams } from "react-router-dom";
import { faq as faqApi } from "../../apis";
import { PageContainer, PageContent, PageHeaders } from "../../components/Layout";
import Form from "./Form";

const StaffEdit = () => {
  const params = useParams();
  const [action, setAction] = React.useState([]);

  const reload = React.useCallback(async (signal) => {
    let res = await faqApi.get(params.id, null, { signal });

    setAction(["update", res]);
  }, [params.id]);

  React.useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    reload(signal);

    return () => abortController.abort();
  }, [reload]);

  return (
    <PageContainer>
      <PageHeaders title="Нийтлэг асуулт хариулт засах" />
      <Spin spinning={!action[1]}>
        <PageContent>
          { action[1] && <Form action={action} />}
        </PageContent>
      </Spin>
    </PageContainer>
  );
};

export default StaffEdit;